import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const backgroundColourChangeSections = gsap.utils.toArray('[data-bg-colour]');

if (backgroundColourChangeSections.length > 0) {
    backgroundColourChangeSections.forEach((section) => {
        const initialColor = section.dataset.bgColour || "#EFF0F2";
        const targetColor = section.dataset.bgTargetColour || "#EEEDE8";

        gsap.set(section, { backgroundColor: initialColor });

        gsap.to(section, {
            scrollTrigger: {
                trigger: section,
                start: "top 50%",
                end: "bottom center",
                toggleActions: "play pause resume reverse",
                triggerOnce: true,
            },
            backgroundColor: targetColor,
            ease: "power2.in",
        });
    });
};